import { Suspense } from 'react';
import { useAtom, useAtomValue } from 'jotai';
import T from '@wojtekmaj/react-t';

import { Heading, Items, Wrapper } from './rewards_and_coupons.styles';

import LoadingText from '../../../loading_text';
import CouponItem from './coupon_item';
import RewardItem from './reward_item';

import {
  redeemableTransactionsQuery,
  vendorCardCouponsState,
  vendorCardRewardsState,
  vendorCardSubscriptionIdState,
} from '../../../../store';

function RewardsAndCouponsContent() {
  const cardSubscriptionId = useAtomValue(vendorCardSubscriptionIdState);
  const coupons = useAtomValue(vendorCardCouponsState);
  const [redeemableTransactions, setRedeemableTransactions] = useAtom(
    redeemableTransactionsQuery(cardSubscriptionId),
  );
  /**
   * DO NOT REMOVE - prevents several individual requests via vendorCardRewardQuery
   */
  useAtomValue(vendorCardRewardsState);

  const activatedCoupons = coupons.filter((coupon) => coupon.is_activated);

  const hasItems = redeemableTransactions.length || activatedCoupons.length;

  if (!hasItems) {
    return null;
  }

  return (
    <Wrapper>
      <Heading>
        <T>My rewards and coupons</T>
      </Heading>
      <Items>
        {redeemableTransactions.map((transaction) => (
          <RewardItem
            key={transaction._id}
            setRedeemableTransactions={setRedeemableTransactions}
            transaction={transaction}
          />
        ))}
        {activatedCoupons.map((coupon) => (
          <CouponItem couponId={coupon._id} key={coupon._id} />
        ))}
      </Items>
    </Wrapper>
  );
}

export default function RewardsAndCoupons() {
  return (
    <Suspense
      fallback={
        <Wrapper>
          <Heading>
            <T>My rewards and coupons</T>
          </Heading>
          <LoadingText />
        </Wrapper>
      }
    >
      <RewardsAndCouponsContent />
    </Suspense>
  );
}
